// Convertit une description markdown (venant de la base) en un court extrait texte,
// pour l'affichage sur les cartes produits (accueil, catégories, catalogue). Sans ça, le
// markdown brut ("### **Titre**...") ou "undefined" (quand la description est vide et qu'on
// concatène avec une chaîne) s'affichaient directement — voir ROADMAP-2026-09.md, A2.2.
export function markdownToExcerpt(markdown, maxLength = 120) {
  if (!markdown) return '';

  let text = String(markdown)
    .replace(/^\s{0,3}#{1,6}\s+/gm, '')       // # Titre -> ''
    .replace(/^\s{0,3}>\s?/gm, '')            // > citation -> ''
    .replace(/^\s{0,3}[-*+]\s+/gm, '')        // - item de liste -> ''
    .replace(/!\[([^\]]*)\]\([^)]*\)/g, '')   // image markdown -> supprimée
    .replace(/\[([^\]]*)\]\([^)]*\)/g, '$1')  // [texte](lien) -> texte
    .replace(/\*\*([^*]+)\*\*/g, '$1')        // **gras** -> gras
    .replace(/\*([^*]+)\*/g, '$1')            // *italique* -> italique
    .replace(/`([^`]+)`/g, '$1')              // `code` -> code
    .replace(/\r?\n+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

  if (!text) return '';
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).replace(/\s+\S*$/, '').trim() + '…';
}
